import { TabList, TabPanel, TabPanels, Tabs, Tab, Box } from '@chakra-ui/react';
import React from 'react'
import Attachment from '../../Frontend/shop/utils/attachment/Attachment';
import Notes from '../../Frontend/shop/utils/notes/Notes';
import { useLocation } from 'react-router-dom';
import ShadeDetail from './ShadesDetail';

export default function Shade() {
     const location = useLocation();
       const shadeId = location.state?.id;
       console.log("shadeId",shadeId);
       

  return (
    <Box>
        <Tabs>
            <TabList>
                <Tab>
                    Overview
                </Tab>
                {/* <Tab>
                    Notes
                </Tab>
                <Tab>
                    Attachment
                </Tab> */}
            </TabList>

            <TabPanels>
            <TabPanel>
                <ShadeDetail shadeId={shadeId} />
            </TabPanel>
            {/* <TabPanel>
                <Notes />
            </TabPanel>
            <TabPanel>
                <Attachment />
            </TabPanel> */}
            </TabPanels>
        </Tabs>
    </Box>
  )
}
